import { styled } from "goober";
import type { Ref } from "react";
import type { NetworkDestination } from "../../../../db/schema";
import { Button } from "../../Button";
import { Input } from "../../Input";
import { SegmentedControl } from "../../SegmentedControl";
import { Text } from "../../Text";
import { Tooltip } from "../../Tooltip";
import type { DestinationDraft } from "./destinationDraft";

type DestinationType = NetworkDestination["type"];

const Row = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export function DestinationInput({
  type,
  onTypeChange,
  draft,
  onAdd,
  inputRef,
}: {
  type: DestinationType;
  onTypeChange: (type: DestinationType) => void;
  draft: DestinationDraft;
  onAdd: (destination: NetworkDestination) => void;
  inputRef?: Ref<HTMLInputElement>;
}) {
  const add = () => {
    const destination = draft.attempt();
    if (destination) onAdd(destination);
  };
  return (
    <>
      <Row>
        <SegmentedControl
          options={["Hostname", "CIDR"] as const}
          tabWidth={80}
          value={type === "cidr" ? "CIDR" : "Hostname"}
          onChange={(v) => onTypeChange(v === "CIDR" ? "cidr" : "hostnameGlob")}
        />
        <Input
          ref={inputRef}
          placeholder={
            type === "hostnameGlob" ? "*.internal.acme.com" : "10.0.0.0/16"
          }
          value={draft.draft}
          onChange={(e) => draft.setDraft(e.target.value)}
          onBlur={draft.settle}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              add();
            }
          }}
          style={{ flex: 1, minWidth: 0 }}
        />
        <Tooltip
          content={draft.disabledReason}
          hidden={draft.disabledReason === null}
        >
          <Button
            size="l"
            variant="subtle"
            icon="plus"
            onClick={add}
            disabled={draft.destination === null}
          >
            Add
          </Button>
        </Tooltip>
      </Row>
      {draft.hint && (
        <Text variant="text-small" color="var(--text-error)">
          {draft.hint}
        </Text>
      )}
    </>
  );
}
